module.exports = __webpack_public_path__ + "static/screenshot_shooting-eb7d370782c162e8fd0ff43c239b1449.png";